<template>

<com-item name="hindex.compare" :size="size" :loading="loading" :no-border="true" :stacked="true" title="H-index" :is-column="true">

	<template v-slot:about>

		<p>See how {{ your }} h-index size compares to others.</p>

	</template>

	<template v-slot:stats>

		<div class="compare">

			<app-visualisation-percentile :data="graph" class="compare-graph" />

			<div class="compare-metrics">

				<com-overview :inline="true" :inset="true" type="number" :value="data.metrics.users" :label="(data.metrics.users > 1) ? 'Users' : 'User'" />

				<com-overview :inline="true" :inset="true" type="template" :value="data.metrics.percentile | nth(true)" label="Percentile" />
				
				<com-overview :inline="true" :inset="true" :theme="(data.metrics.median >= 0) ? 'green': 'red'" type="number" :value="data.metrics.median | abs" label="vs Median" :caret="(data.metrics.median >= 0) ? 'up': 'down'" />

			</div>

		</div>

	</template>

</com-item>

</template>

<script>

import comOverview from './../common/Overview'
import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem,
		'com-overview': comOverview
	},

	data: function() {

		return {
			graph: {
				plain: true,
				datasets: [
					{ type: 'bar', data: [], highlight: false, backgroundColor: '#4881bb', tooltip: '{{value}} user{{value.plural}} <small>{{x.label}} {{x.sublabel}}</small>' }
				],
				axis: {
					x: {
						labels: []
					},
					y: {
						min: 10,
						points: 10
					}
				}
			}
		}

	},

	computed: {

		loading: function() {

			return this.fetching === 'all' 

		},

		data: function() {

			return this.$store.getters['page/insights/hindex/peers']

		},

		active: function() {

			return this.data.histogram.data.length && !this.loading

		}

	},

	watch: {

		compare: function() {

			this.visualise()

		}

	},

	created: function() {

		this.visualise()

	},

	methods: {

		visualise: function() {

			this.graph.datasets[0].data = []
			this.graph.axis.x.labels = []

			this.graph.datasets[0].highlight = this.data.histogram.position

			for (var i = 1; i <= this.data.histogram.data.length; i++) {

				this.graph.axis.x.labels.push({
					label: this.data.histogram.labels[i - 1],
					sublabel: ''
				})

				this.graph.datasets[0].data.push(this.data.histogram.data[i - 1])

			}

		}
		
	}

}

</script>

<style scoped>

.compare {
	display: grid;
	height: 100%;
	grid-template-columns: 1fr;
	grid-template-rows: 1fr 80px;
	grid-gap: 4px;
}

.compare-graph {
	width: 100%;
	flex-grow: 1;
	border: 1px solid #ddd;
	background-color: #fff;
	border-radius: 4px;
}

.compare-metrics {
	flex-shrink: 0;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
	align-items: center;
	grid-gap: 4px;
}

.compare-metrics >>> .overview-item {
	border: 1px solid #ddd;
	border-radius: 4px;
	height: 100%;
	background-color: #fff;
	align-content: center;
	grid-template-rows: auto auto;
}

.compare-metrics >>> .overview-item:first-child .overview-item-value {
	height: 28px;
}

.compare-metrics >>> .overview-item-label {
	margin-top: 8px;
}

</style>